import React, { useState } from "react";
import CartTable2 from "../../../../components/AdminTable/CartTale2";


function DetailedPurchaseReport() {
  const [columns] = useState([
    {
      header: "SN",
      accessorKey: "SN",
    },
    {
      header: "Date",
      accessorKey: "Date",
    },
    {
      header: "Ingredient(Code)",
      accessorKey: "Ingredient(Code)",
    },

    {
      header: "Unit Price",
      accessorKey: "Unit Price",
    },
    {
      header: "Quantity/Amount",
      accessorKey: "Quantity/Amount",
    },
    {
      header: "Value(Qty)",
      accessorKey: "Value(Qty)",
    }, {
        header: "Amount",
        accessorKey: "Amount",
      }, {
        header: "Vat Percentage",
        accessorKey: "Vat Percentage",
      }, {
        header: "Tax method",
        accessorKey: "Tax method",
      }, {
        header: "Vat",
        accessorKey: "Vat",
      }, {
        header: "Total",
        accessorKey: "Total",
      },
  ]);
  const [data] = useState([]);
  const [buttonDataa] = useState([
    {
      buttonText: "Submit",
    },
  ]);

  return (
    <main>
      <CartTable2
        data={data}
        columns={columns}
        heading={"Detailed Purchase Report"}
        buttonDataa={buttonDataa}
      />
    </main>
  );
}

export default DetailedPurchaseReport;
